import { addDays, format } from "date-fns";
import { NumberFormatValues } from "@common/schemas/domains/reportSettings/number-format-setting.schema";
import { formatMoneyColumnHeader } from "@common/helpers/number";
import { fullDateLongFormat } from "@common/helpers/date";
import { PreviewArAgingDetailDataset } from "./previewTypes";
import { previewRowPercent } from "./previewPercent";
import { AmountCell } from "./AmountCell";
import { PercentCell } from "./PercentCell";
import styles from "./ReportPreview.module.scss";

interface Props {
    dataset: PreviewArAgingDetailDataset;
    numberFormat: NumberFormatValues;
    asOf: Date | null;
}

const formatOffsetDate = (asOf: Date | null, offset: number) =>
    asOf === null ? "" : format(addDays(asOf, offset), fullDateLongFormat);

export const ArAgingDetailTable = ({ dataset, numberFormat, asOf }: Props) => (
    <div className={styles.table}>
        <div className={styles.columnHeader} data-columns="ar-aging-detail">
            <span>{dataset.dateHeader}</span>
            <span>{dataset.customerHeader}</span>
            <span>{dataset.dueDateHeader}</span>
            <span className={styles.amountCell}>
                {formatMoneyColumnHeader(dataset.amountHeader, numberFormat)}
            </span>
            <span className={styles.amountCell}>
                {formatMoneyColumnHeader(dataset.openHeader, numberFormat)}
            </span>
            <span className={styles.percentCell}>{dataset.percentHeader}</span>
        </div>
        {dataset.rows.map((row) => {
            if (row.kind === "section") {
                return (
                    <div key={row.id} className={styles.ledgerAccountRow}>
                        {row.label}
                    </div>
                );
            }
            const isInvoice = row.kind === "line";
            return (
                <div
                    key={row.id}
                    className={styles.gridRow}
                    data-columns="ar-aging-detail"
                    data-kind={isInvoice ? "line" : "total"}
                    data-top-border={row.hasTopBorder || undefined}
                >
                    <span>
                        {isInvoice && formatOffsetDate(asOf, row.dateOffset)}
                    </span>
                    <span>{row.label}</span>
                    <span>
                        {isInvoice && formatOffsetDate(asOf, row.dueDateOffset)}
                    </span>
                    <AmountCell
                        value={row.amount}
                        numberFormat={numberFormat}
                    />
                    <AmountCell value={row.open} numberFormat={numberFormat} />
                    <PercentCell
                        value={previewRowPercent({
                            amount: row.open,
                            percentBase: dataset.percentBase,
                        })}
                        numberFormat={numberFormat}
                    />
                </div>
            );
        })}
    </div>
);
